import React from "react";
import { Modal, ModalBuilder, Table } from "@redriver/cinnamon";
import { unarchiveClientAuthorisedSignatory } from "features/Companies/Customers/Signatories/Actions/actions";

const UnarchiveSignatory = ({ signatoryId, clientId, forceUpdate }) => {
  return (
    <ModalBuilder
      withForm
      submitAction={unarchiveClientAuthorisedSignatory}
      submitParams={{ signatoryId, clientId }}
      onSubmitted={forceUpdate}
      loadParams={{ signatoryId, clientId }}
      renderTrigger={(showModal) => (
        <Table.MenuItem onClick={showModal}>Un-Archive</Table.MenuItem>
      )}
      renderModal={(modalProps) => (
        <Modal.Edit
          {...modalProps}
          header="Un-Archive Signatory"
          submitLabel="Un-Archive"
        >
          <span>Are you sure you would like to un-archive this signatory?</span>
        </Modal.Edit>
      )}
    />
  );
};
export default UnarchiveSignatory;
